import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type React from 'react';
import { NAVY } from 'styles/tokens';

interface SuccessRateDisplayProps {
  successRate: number;
  totalExecutions: number;
}

const SuccessRateDisplay: React.FC<SuccessRateDisplayProps> = ({ successRate, totalExecutions }) => {
  return (
    <Box
      sx={{
        mb: 1,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: alpha(NAVY, 0.6),
          mb: 0.5,
        }}
      >
        Tasa de Éxito ({totalExecutions} {totalExecutions === 1 ? 'solicitud' : 'solicitudes'})
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontWeight: 700,
          color: NAVY,
        }}
      >
        {successRate.toFixed(1)}%
      </Typography>
    </Box>
  );
};

export default SuccessRateDisplay;
